// Category tile clicks on the PLP — live parity (sections/plp-filters-blocks.liquid)
if (!customElements.get('plp-filters-blocks')) {
  class PlpFiltersBlocks extends HTMLElement {
    constructor() {
      super();
      this.handleTileClick = this.handleTileClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleTileClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleTileClick);
    }

    /**
     * Applies the tile's Style (product type) filter single-select, then scrolls to the grid.
     * @param {MouseEvent} event - Click event delegated from the section root.
     * @returns {void}
     */
    handleTileClick(event) {
      const trigger = event.target.closest('[data-plp-style-filter]');
      if (!trigger) return;

      // A tile with a link navigates normally, only link-less tiles filter in place.
      if (trigger.getAttribute('href')?.trim()) return;
      event.preventDefault();

      const targetLabel = trigger.getAttribute('data-plp-style-filter').trim().toLowerCase();
      const checkboxes = Array.from(document.querySelectorAll('input[name="filter.p.product_type"]'));

      const match = checkboxes.find(
        /**
         * @param {HTMLInputElement} checkbox - Product type filter checkbox.
         * @returns {boolean} True when the checkbox label matches the tile label.
         */
        (checkbox) => {
          const labelText = checkbox.closest('label')?.querySelector('.filter-label');
          return labelText?.textContent.trim().toLowerCase() === targetLabel;
        },
      );

      if (match) {
        let changed = false;

        // Keep this filter single-select when triggered from these tiles: unchecking
        for (const checkbox of checkboxes) {
          if (checkbox !== match && checkbox.checked) {
            checkbox.checked = false;
            changed = true;
          }
        }

        if (!match.checked) {
          match.checked = true;
          changed = true;
        }

        // Set + dispatch "change" directly (skip .click()) so the click never bubbles
        // into the facet group's own toggle handler, which would close it again.
        if (changed) {
          match.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      const productGrid = document.querySelector('.product-grid-container');
      if (productGrid) {
        const scrollOffset = 50;
        const targetPosition = productGrid.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }
    }
  }

  customElements.define('plp-filters-blocks', PlpFiltersBlocks);
}
